export type CalloutKind = 'tip' | 'note' | 'warning';

interface MdastNode {
  type: string;
  value?: string;
  children?: MdastNode[];
  data?: { hName?: string; hProperties?: Record<string, unknown> };
}

const MARKER = /^\[!(tip|note|warning)\]\s*/i;

function convertBlockquote(node: MdastNode): void {
  const first = node.children?.[0];
  const text = first?.type === 'paragraph' ? first.children?.[0] : undefined;
  if (!text || text.type !== 'text' || !text.value) return;
  const match = MARKER.exec(text.value);
  if (!match) return;

  const kind = match[1].toLowerCase() as CalloutKind;
  text.value = text.value.slice(match[0].length);
  if (!text.value) {
    first!.children!.shift();
    if (first!.children!.length === 0) node.children!.shift();
  }
  node.data = {
    ...(node.data ?? {}),
    hName: 'div',
    hProperties: {
      ...(node.data?.hProperties ?? {}),
      'data-callout': kind,
    },
  };
}

function walk(node: MdastNode): void {
  if (node.type === 'blockquote') convertBlockquote(node);
  node.children?.forEach(walk);
}

/** remark plugin: `> [!TIP]` / `[!NOTE]` / `[!WARNING]` blockquotes become
 * callout divs. */
export function remarkAlerts() {
  return (tree: MdastNode) => walk(tree);
}
